import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '../../../Tooltip/Tooltip';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { Typography } from '../../../Typography';
import { Badge } from '../../../Badge';
import {
  DialogTitleRoot,
  HeaderRoot,
  TitleContainerRoot,
  ContainerRoot
} from './DialogHeader.style';
import { dialogHeaderClasses as classes } from './dialogHeaderClasses';

const DialogHeader = ({
  title,
  onClose: handleClose,
  TooltipProps,
  DialogTitleProps,
  BadgeProps,
  description,
  disclaimer,
  image,
  actions,
  ...rest
}) => {
  return (
    <DialogTitleRoot
      data-qa-id="dialog-header"
      onClose={handleClose}
      {...DialogTitleProps}
      {...rest}>
      <HeaderRoot>
        {image && <div className={classes.image}>{image}</div>}
        <TitleContainerRoot>
          <ContainerRoot>
            {disclaimer && (
              <Typography
                variant="caption"
                data-qa-id="dialog-disclaimer"
                className={classes.disclaimer}>
                {disclaimer}
              </Typography>
            )}
            <Tooltip title="Close">
              <IconButton
                data-qa-id="dialog-close-button"
                size="small"
                aria-label="close"
                onClick={handleClose}
                className={classes.closeButton}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </ContainerRoot>
          <Typography variant="h1" data-qa-id="dialog-title">
            {title}
          </Typography>
          {TooltipProps && (
            <Tooltip
              placement="top"
              data-qa-id="dialog-tooltip"
              variant="info"
              {...TooltipProps}>
              <span className={classes.helpIcon}>
                <HelpOutlineOutlinedIcon fontSize="small" />
              </span>
            </Tooltip>
          )}
          {BadgeProps && <Badge className={classes.badge} {...BadgeProps} />}
        </TitleContainerRoot>
        {description && (
          <Typography
            variant="body1"
            data-qa-id="dialog-description"
            className={classes.description}>
            {description}
          </Typography>
        )}
      </HeaderRoot>
      {actions && <div className={classes.actions}>{actions}</div>}
    </DialogTitleRoot>
  );
};

DialogHeader.propTypes = {
  title: PropTypes.string.isRequired,
  /**
   * props available in [Tooltip](./index.html?path=/docs/components-feedback-tooltip--docs) component
   **/
  TooltipProps: PropTypes.object,
  DialogTitleProps: PropTypes.object,
  BadgeProps: PropTypes.object,
  description: PropTypes.node,
  disclaimer: PropTypes.string,
  /** (event:object, reason: string) => void */
  actions: PropTypes.node,
  image: PropTypes.node,
  onClose: PropTypes.func
};

export default DialogHeader;
